<template>
  <div ref="modalRef" :class="cx('overflow-auto max-w-[403px] p-[12px] bg-[--color-neutral-white] relative shadow-[0px_20px_24px_-4px_rgba(0,0,0,0.08),_0px_8px_8px_-4px_rgba(0,0,0,0.03)]', $attrs.class)">
    <div class="relative flex flex-col gap-[16px] p-[12px]">
      <button v-if="closeable" class="absolute right-[-6px] top-[-6px] flex size-[24px] items-center justify-center" @click="emit('close')">
        <Icon name="x" class="size-[11px] text-[--color-neutral-neutral-lighter]" />
      </button>
      <h5
        :class="cx('flex items-center gap-[4px] text-[--color-neutral-black] text-regular-semi-bold', headerClass)"
      >
        <slot v-if="$slots.header" name="header" />
        <template v-else>
          {{ header }}
        </template>
        <Icon
          v-if="headerIcon"
          :name="headerIcon"
          :height="14"
          :width="14"
        />
      </h5>
      <div v-if="$slots.message" :class="cx('text-small-normal text-[--color-neutral-black] max-h-[70vh] overflow-y-auto', bodyClass)">
        <slot name="message" />
      </div>
      <div v-else :class="cx('text-small-normal text-[--color-neutral-black] max-h-[70vh] overflow-y-auto', bodyClass)">
        <slot name="body" />
      </div>

      <div
        v-if="$slots.footer"
        class="sticky bottom-0 left-0 z-10 flex items-center gap-[8px] bg-[--color-neutral-white]"
        :class="cx({
          'border-t border-[--v3-global-divider] pt-6': hasDivider,
        }, footerClass)"
      >
        <slot name="footer" />
      </div>
      <div v-else-if="$slots.buttons" :class="cx('flex items-center gap-[8px] sticky bottom-0 left-0 z-10 bg-[--color-neutral-white]', footerClass)">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onClickOutside } from '@vueuse/core';
import { defineEmits, onMounted, ref } from 'vue';
import { useSlots } from 'vue';

import Icon from '@/common/components/atoms/Icon';
import { cx } from '@/helpers/cva';

defineOptions({
  inheritAttrs: false,
});

withDefaults(defineProps<{
  header?: string,
  closeable?: boolean,
  headerIcon?: string,
  headerClass?: string | object,
  footerClass?: string | object,
  bodyClass?: string,
  hasDivider?: boolean,
}>(), {
  header: undefined,
  closeable: false,
  headerIcon: null,
  headerClass: '',
  bodyClass: '',
  footerClass: '',
  hasDivider: false,
});

const emit = defineEmits<{
  'onClickOutside': [],
  'close': [],
}>();

const slots = useSlots();

const modalRef = ref(null);
onClickOutside(modalRef, () => emit('onClickOutside'));

onMounted(() => {
  if (slots.message) {
    console.warn('The "message" slot is deprecated. Use the "body" slot instead.');
  }

  if (slots.buttons) {
    console.warn('The "buttons" slot is deprecated. Use the "footer" slot instead.');
  }
});
</script>


